import { gql } from 'graphql-request';

import { DetectedIdProductsGroup } from '../productsTypes';
import { CacheFetchProductsQueryResponse } from './fetchCacheProducts.query';

export interface FetchCacheGroupedByDetectedIdProductsQueryResponse {
  groupedByDetectedIdProducts: {
    nodes: DetectedIdProductsGroup<CacheFetchProductsQueryResponse>[];
  };
}

export const FETCH_CACHE_GROUPED_BY_DETECTED_ID_PRODUCTS_QUERY = gql`
  query CacheGroupedByDetectedIdProducts(
    $filters: ProductsFilters!
    $limit: Int
  ) {
    groupedByDetectedIdProducts(filters: $filters, limit: $limit) {
      nodes {
        detectedId
        products {
          blocked
          favorite
          id
          uuid
          nanoId
          sku
          name
          nda
          createdAt
          updatedAt
          renderTypes {
            id
            name
          }
          image {
            id
            uuid
            file
          }
          maxFile {
            createdAt
          }
          previewModel {
            id
            uuid
            file
            size
            name
          }
          brand {
            id
            uuid
            name
            localizedName
          }
          tags {
            id
            localizedName
          }
        }
      }
    }
  }
`;
